// Show appstore in deeplinks if link for iphone is clicked
;
(function () {

    const $link = $('.js-m-modal--deeplink-active-tab');
    if (!$link.length) return false;

    let modalId = '';
    let $active_tab = '';

    $link.on('click', function () {
        modalId = $(this).data('modalTarget');
        const tab = $(this).data('deeplinkActiveTab');
        const tabs_group = $('#' + tab).data('tabsGroup');

        $('[data-tabs-group="' + tabs_group +'"]').each(function () {
            if ($(this).hasClass('is-active')) {
                $active_tab = $(this).attr('id');
            }
        });

        $('[data-tabs-show="' + tab +'"]').click();
        window.deeplink_active_tab = true;
    });

    $(document).on('modalClosed', function(e, modalTargetId) {
        if (modalId === modalTargetId && window.deeplink_active_tab) {
            $('[data-tabs-show="' + $active_tab +'"]').click();
            window.deeplink_active_tab = false;
        }
    });
})();